export default __webpack_public_path__ + "src/assets/yieldlab_logo.png";